/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'timeline': {
    width: 11,
    height: 11,
    viewBox: '0 0 11 11',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M2.595 6.454v-2.36M8.232 6.454v-2.36M6.757.75h3v3h-3zM8.257 9.957l-1.5-3h3zM1 .75h3v3H1zM3.25 6.972a1.5 1.5 0 1 1-1.5 2.598 1.5 1.5 0 0 1 1.5-2.598z"/></g>'
  }
})
